export default __webpack_public_path__ + "static/media/arrow-right.f7cb91d1.svg";